import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormCheckboxComponent } from '../../../sale/components/form-checkbox/form-checkbox.component';
import { FormDatepickerComponent } from '../../../sale/components/form-datepicker/form-datepicker.component';
import { FormInputComponent } from '../../../sale/components/form-field/form-input.component';
import { EmploymentHistoryFormGroup } from '../../interfaces/employment-history';
import { AddressFormGroup } from '../../interfaces/address';
import { FormsAddressComponent } from '../forms-address/forms-address.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-forms-employment-history',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormsAddressComponent, MatDatepickerModule, MatFormFieldModule, MatInputModule, FormInputComponent, FormDatepickerComponent, FormCheckboxComponent],
    templateUrl: './forms-employment-history.component.html',
    styleUrl: './forms-employment-history.component.scss',
})
export class FormsEmploymentHistoryComponent {
    @Input() public addressTitle: string | undefined;

    @Input() public formGroup: EmploymentHistoryFormGroup | undefined;

    @Input() public title: string | undefined;

    public get address(): AddressFormGroup | undefined {
        return this.formGroup?.controls.address;
    }

}
